// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueResource from 'vue-resource'
import '@/material'
import constants from '@/constants.js'
import auth from '@/auth.js'
import App from '@/App'
import router from '@/router'
import store from '@/vuex/store'
import 'babel-polyfill'
import {library} from '@fortawesome/fontawesome-svg-core'
import {faLightbulb, faGlobe, faChartArea, faAngleLeft, faAngleRight} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import VueTour from 'vue-tour'
import 'vue-tour/dist/vue-tour.css'
import {thousandsSeparator} from '@/util'

(async () => {
  Vue.config.productionTip = false
  Vue.prototype.$constants = constants

  Vue.use(VueResource)
  Vue.use(VueTour)

  library.add(faLightbulb, faGlobe, faChartArea, faAngleLeft, faAngleRight)

  Vue.component('font-awesome-icon', FontAwesomeIcon)

  Vue.config.productionTip = false

  // shorten text to a certain character length (stop value) for display reasons
  // clamp is an optional string to indicate there is more text; defaults to "..."
  // https://stackoverflow.com/a/35071765
  Vue.filter('truncate', function (text, stop, clamp) {
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
  })

  // display numbers in better readable form by applying the thousandsSeparator function
  // (integers are not getting decimals added to them)
  // filter is only applied if value exists / has already been retrieved from API
  Vue.filter('digitGrouping', function (value, trun = false) {
    if (typeof value !== 'undefined') {
      return thousandsSeparator(value, 3, 'en', trun)
    }
  })

  let apiVersion = constants.API_VERSION_NO
  let apiVersionSource = 'file'
  let env = process.env.NODE_ENV
  let apiEnv = process.env.NODE_ENV
  if (env === 'dev_server') {
    apiEnv = 'development'
  }

  // Authentication check
  auth.setupAuthInterceptor()
  await auth.checkCallback()

  // load topo map
  const mapUrl = `${Vue.prototype.$constants.API_BASEURL}/v${Vue.prototype.$constants.API_VERSION_NO}/metadata/map_tool`

  // load geoJSON from the API
  const { data } = await Vue
    .http
    .get(mapUrl)

  constants.TOPO_JSON = data

  // load API version number from API
  Vue.http.get(Vue.prototype.$constants.API_BASEURL + '/version', {params: {env: apiEnv}}).then(response => {
    // Vue.http.get(Vue.prototype.$constants.API_BASEURL + '/version', {params: {env: 'staging'}}).then(response => {
    if (typeof response.data.version_no === 'number') {
      // TODO: Remove if not needed anymore
      // overwrite API version no. for dev server and staging if file uses more recent version than the API provides
      if (constants.API_VERSION_NO > response.data.version_no && (env === 'dev_server' || env === 'staging')) {
        apiVersionSource = 'file - more recent than api: ' + response.data.version_no
      } else {
        apiVersion = response.data.version_no
        apiVersionSource = 'api'
      }
    }
  }).catch(() => {
    // endpoint not available, fall back to hardcoded variable for API version
  }).finally(() => {
    if (process.env.API_VERSION !== undefined) {
      // allow passing of alternative API version numbers for testing/development
      apiVersion = process.env.API_VERSION
      apiVersionSource = 'cli flag'
    }

    Vue.prototype.$apiVersion = apiVersion
    Vue.http.options.root = Vue.prototype.$constants.API_BASEURL + '/v' + Vue.prototype.$apiVersion
    console.debug('API v' + Vue.prototype.$apiVersion + ' (via ' + apiVersionSource + ')')

    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      components: {App},
      template: '<App/>'
    })
  })
})()



// WEBPACK FOOTER //
// ./src/main.js